exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.my-padding {\n  padding: 1rem 1rem;\n  margin: auto;\n}\n/*# sourceMappingURL=src/pages/wiki-list.css.map */", "", {"version":3,"sources":["D:/ts2/src/pages/src/pages/wiki-list.vue","D:/ts2/src/pages/wiki-list.vue"],"names":[],"mappings":";AAmCA;EACE,mBAAA;EACA,aAAA;CClCD;AACD,mDAAmD","file":"wiki-list.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.my-padding\n  padding 1rem 1rem\n  margin auto\n",".my-padding {\n  padding: 1rem 1rem;\n  margin: auto;\n}\n/*# sourceMappingURL=src/pages/wiki-list.css.map */"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":true}!./node_modules/stylus-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/wiki-list.vue
// module id = jQad
// module chunks = 3